import { func } from 'prop-types';
import React, { createContext, useCallback, useContext } from 'react';

const FormContext = createContext();

export const getOnChange = (onChange, onChangeProp) => (...args) => {
  onChange(...args);

  if (onChangeProp) {
    onChangeProp(...args);
  }
};

export const withFormContext = WrappedComponent => {
  const FormContextConsumer = (props) => {
    const { onChange, ...value } = useContext(FormContext);

    return (
      <WrappedComponent
        {...props}
        {...value}
        onChange={useCallback(getOnChange(onChange, props.onChange), [props.onChange])}
      />
    );
  };

  FormContextConsumer.propTypes = { onChange: func };

  FormContextConsumer.defaultProps = { onChange: undefined };

  return FormContextConsumer;
};

export default FormContext;
